<!--
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2026-02-10 09:53:56
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2026-02-11 15:32:38
 * @FilePath: \goodmanger\src\views\Home.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="homeBodyBox">
      <el-header class="header">
        <h3>建盟领惠商品管理平台</h3>
        <div class="user-info">
          <div class="user-avatar">
            <i class="el-icon-user"></i>
          </div>
          <span>管理员</span>
        </div>
      </el-header>
  <el-container>
    <el-aside width="250px">
      

      <el-menu :default-active="activeMenu" class="sidebar-menu" router>
        <el-menu-item index="/goods-management">
          <i class="el-icon-s-grid"></i>
          <span slot="title">商品管理</span>
        </el-menu-item>
        <el-menu-item index="/goods-type-management">
          <i class="el-icon-s-marketing"></i>
          <span slot="title">类型管理</span>
        </el-menu-item>
        <el-menu-item index="/order-management">
          <i class="el-icon-document"></i>
          <span slot="title">订单管理</span>
        </el-menu-item>
        <el-menu-item index="/info-statistics">
          <i class="el-icon-data-analysis"></i>
          <span slot="title">信息统计</span>
        </el-menu-item>
        <el-menu-item index="/">
          <i class="el-icon-switch-button"></i>
          <span slot="title">退出登录</span>
        </el-menu-item>
      </el-menu>
  
    </el-aside>
    <el-main>
      <router-view style="height: 100%;width: 100%;"></router-view>
    </el-main>
  </el-container>
  </div>
</template>
<script>
export default {
  name: 'HomePage',
  data() {
    return {
      activeMenu: '/goods-management',
    }
  },
}
</script>
<style scoped>
.homeBodyBox {
  width: 100vw;
  height: 100vh;
  /* background-color: #f5f5f5; */
 
}
.el-header{
    height: 60px;
    line-height: 60px;
    padding: 0 20px;
    /* background-color: #ff0000; */
}
.el-aside{
  /* background-color: #ff0000; */
  height: calc(100vh - 60px);
}
.el-main{
  /* background-color: aqua; */
}
</style>
